import { Grid, Skeleton, Stack } from "@mui/material";

export const InboundTrafficAssociationSkeleton = () => {
    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width="20%"
                    height="3em"
                />
            </Grid>
            <Grid size={12}>
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width="50%"
                    height="3em"
                />
            </Grid>
            <Grid container size={12}>
                <Grid size={6}>
                    <Skeleton
                        animation="wave"
                        variant="rectangular"
                        width="100%"
                        height="3em"
                    />
                </Grid>
                <Grid container justifyContent="space-evenly" size={6}>
                    <Grid size={5}>
                        <Skeleton
                            animation="wave"
                            variant="rectangular"
                            width="100%"
                            height="3em"
                        />
                    </Grid>
                    <Grid size={5}>
                        <Skeleton
                            animation="wave"
                            variant="rectangular"
                            width="100%"
                            height="3em"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width="50%"
                    height="3em"
                />
            </Grid>
            <Grid size={12}>
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width="50%"
                    height="3em"
                />
            </Grid>
            <Grid size={12}>
                <Stack direction="row" spacing={3} justifyContent="flex-end">
                    <Skeleton
                        animation="wave"
                        variant="rectangular"
                        width="10%"
                        height="2em"
                    />
                    <Skeleton
                        animation="wave"
                        variant="rectangular"
                        width="10%"
                        height="2em"
                    />
                </Stack>
            </Grid>
        </Grid>
    );
};
